export default __webpack_public_path__ + "static/media/uae.b2632201.svg";